require('bootstrap/dist/css/bootstrap.css');
require('bootstrap-icons/font/bootstrap-icons.css');
require('bootstrap');
require('./css/start.css');
require('./css/animate.css');
require('./css/cookie-consent.css');
require('./js/cookie-consent.js');

// Matomo.
require('./js/matomo');
